import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-business" }
const _hoisted_2 = { class: "edit-business__title" }
const _hoisted_3 = { class: "edit-business__header__tab" }

import { i18n } from '@/i18n';
import EditIndividualBusiness from '../components/EditIndividualBusiness.vue';
import RegisterBusinessPageTab from '@/corePagesModule/components/RegisterBusinessPageTab.vue';
import EditIndividualBusinessPageTab from '../components/EditIndividualBusinessPageTab.vue';
import { useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import EditIndividualBaseBusiness from '../components/EditIndividualBaseBusiness.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.t;
const route = useRoute();

const isNowViewIndividual = computed(() => {
  return route.path === '/business-edit-individual';
});

// Note: NewBaseTableContentに展開機能が実装されるまで関連取引は別テーブルで表示する
const isNowIndividualViewBaseBusiness = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('登録/入力')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(RegisterBusinessPageTab)
    ]),
    (isNowViewIndividual.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(EditIndividualBusinessPageTab, {
            "is-base-business": isNowIndividualViewBaseBusiness.value,
            onClick: _cache[0] || (_cache[0] = 
          (view) => {
            isNowIndividualViewBaseBusiness.value = view;
          }
        )
          }, null, 8, ["is-base-business"]),
          (isNowIndividualViewBaseBusiness.value)
            ? (_openBlock(), _createBlock(EditIndividualBaseBusiness, { key: 0 }))
            : (_openBlock(), _createBlock(EditIndividualBusiness, { key: 1 }))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
  ]))
}
}

})